import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSettingsToggle2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="settings-toggle-2"><path d="M1.75 12C1.75 9.10051 4.10051 6.75 7 6.75H17C19.8995 6.75 22.25 9.10051 22.25 12C22.25 14.8995 19.8995 17.25 17 17.25H7C4.10051 17.25 1.75 14.8995 1.75 12Z" stroke="currentColor" strokeWidth="1.5"/><path d="M11.75 12C11.75 9.10051 14.1005 6.75 17 6.75C19.8995 6.75 22.25 9.10051 22.25 12C22.25 14.8995 19.8995 17.25 17 17.25C14.1005 17.25 11.75 14.8995 11.75 12Z" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSettingsToggle2;
